import { IType } from './common';
import { IMappedType } from './mapped-type.interface';
import {
  applyIsOptionalDecorator,
  inheritPropertyInitializers,
  inheritTransformationMetadata,
  inheritValidationMetadata,
} from './type-helpers.utils';
import { TRemoveFieldsWithType } from './types/remove-fields-with-type.type';

export function PartialType<T>(classRef: IType<T>) {
  abstract class PartialClassType {
    constructor() {
      inheritPropertyInitializers(this, classRef);
    }
  }

  const propertyKeys = inheritValidationMetadata(classRef, PartialClassType);
  inheritTransformationMetadata(classRef, PartialClassType);

  if (propertyKeys) {
    propertyKeys.forEach((key) => {
      applyIsOptionalDecorator(PartialClassType, key);
    });
  }

  Object.defineProperty(PartialClassType, 'name', {
    value: `Partial${classRef.name}`,
  });

  return PartialClassType as IMappedType<
    TRemoveFieldsWithType<Partial<T>, unknown>
  >;
}
